import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES, USER_ROLES } from '../utils/constants';

interface RequireRoleProps {
  children: React.ReactNode;
  requiredRole: string | string[];
  redirectTo?: string;
}

const getDefaultDashboard = (roles?: string[]): string => {
  if (!roles || roles.length === 0) return ROUTES.LOGIN;
  if (roles.includes(USER_ROLES.DEV_TEAM)) return ROUTES.DEV_DASHBOARD;
  if (roles.includes(USER_ROLES.SCHOOL_ADMIN)) return ROUTES.ADMIN_DASHBOARD;
  if (roles.includes(USER_ROLES.TEACHER)) return ROUTES.TEACHER_DASHBOARD;
  if (roles.includes(USER_ROLES.STUDENT)) return ROUTES.STUDENT_DASHBOARD;
  if (roles.includes(USER_ROLES.PARENT)) return ROUTES.PARENT_DASHBOARD;
  return ROUTES.LOGIN;
};

export const RequireRole: React.FC<RequireRoleProps> = ({
  children,
  requiredRole,
  redirectTo,
}) => {
  const { hasAnyRole, user } = useAuth();
  const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

  if (!hasAnyRole(roles)) {
    const destination = redirectTo || getDefaultDashboard(user?.roles);
    return <Navigate to={destination} replace />;
  }

  return <>{children}</>;
};

